export const CHANGE_SUBCATEGORY_SELECTED_SUCCESS =
  "CHANGE_PLACE_SUBCATEGORY_SELECTED_SUCCESS";
export const SET_CUSTOMERS_LEGEND = "SET_CUSTOMERS_LEGEND";
export const SET_CUSTOMER_LOCATIONS = "SET_CUSTOMER_LOCATIONS";

export const SET_CUSTOMERS_ATTRIBUTE = "SET_CUSTOMERS_ATTRIBUTE";
export const CLEAR_DATA = "CLEAR_DATA";
